import mutations from './mutations'
import actions from './actions'
export default {
  namespaced: true,
  state: {
    itemGather: {}
  },
  getters: {
    getStationItemState: state => itemId => state.itemGather[itemId] ? state.itemGather[itemId] : {}
  },
  mutations,
  actions
}
